// extracted by mini-css-extract-plugin
module.exports = {"text":"PromoHeader_text__cixx_"};